<template>
    <div class="role-edit-modal">
        <TitleBaseBox :title="title" @close="close" @confirm="confirmClick" @cancel="cancelClick">
            <div class="role-info-list">
                <AddDataPanel :label="nameLabel">
                    <IconInput class="role-name-input" :initValue="initRoleName" @inputChange="nameChange" :placeholder="inputNameLabel" />
                </AddDataPanel>
                <AddDataPanel :label="permissLabel">
                    <div class="permiss-content scroll-tracker">
                        <el-tree
                            ref="tree"
                            node-key="id"
                            default-expand-all
                            :default-checked-keys="defaultKeys"
                            :props="defaultProps"
                            :data="treeData"
                            :check-strictly="checkStricted"
                            show-checkbox
                            @check="handleCheckChange"
                        >
                        </el-tree>
                    </div>
                </AddDataPanel>
                <AddDataPanel :label="remarkLabel" :required="false">
                    <IconInput class="role-name-input" :initValue="remarkData" @inputChange="remarkChange" :placeholder="remarkInputLabel" />
                </AddDataPanel>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import AddDataPanel from "../AddDataPanel";
import i18n from "@/i18n";

export default {
    name: "RoleEditModal",
    props: ["data"],
    data() {
        const seletcted = (this.data.addData && this.data.addData.premit.split(",")) || [];
        return {
            nameVal: "",
            remarkData: (this.data.addData && this.data.addData.remarks) || "",
            initRoleName: (this.data.addData && this.data.addData.roleName) || "",
            defaultProps: {
                children: "children",
                label: "label"
            },
            treeData: [],
            tempKey: seletcted,
            defaultKeys: ["0", ...seletcted],
            checkStricted: true
        };
    },
    computed: {
        nameLabel() {
            return this.$t("zhiji.personnel.roleManage.tabelCloumn.roleName");
        },
        inputNameLabel() {
            return this.$t("zhiji.personnel.roleManage.roleEditModal.inputNameTip");
        },
        permissLabel() {
            return this.$t("zhiji.personnel.roleManage.roleEditModal.permissLabel");
        },
        remarkLabel() {
            return this.$t("zhiji.personnel.roleManage.tabelCloumn.remark");
        },
        editSwitchLabel() {
            return this.$t("zhiji.personnel.roleManage.editPermission");
        },
        remarkInputLabel() {
            return this.$t("zhiji.personnel.roleManage.roleEditModal.remarkInputTip");
        },
        title() {
            return this.data
                ? this.$t("zhiji.personnel.roleManage.roleEditModal.editRoleLabel")
                : this.$t("zhiji.personnel.roleManage.roleEditModal.addRoleLabel");
        }
    },
    components: {
        TitleBaseBox,
        AddDataPanel,
        IconInput
    },
    mounted() {
        this.getPermitTreesData();
    },
    methods: {
        getPermitTreesData() {
            const req = {
                bId: this.$store.state.auth.businessId
            };
            this.zhiji.requestByServiceName("getPermitList", req).then(data => {
                const treeData = [
                    {
                        id: "0",
                        label: this.$t("zhiji.personnel.roleManage.allPermission"),
                        level: 0,
                        text: this.$t("zhiji.personnel.roleManage.allPermission"),
                        parentId: "0",
                        children: data
                    }
                ];
                this.treeData = treeData;
            });
        },
        handleCheckChange(node) {
            const { id, path, children } = node;
            const isCheck = this.tempKey.indexOf(id) === -1;
            const relatedNodes = [id];

            const getChildrenIds = (children) => {
                const ret = [];
                children.forEach(({ id, children }) => {
                    ret.push(id);
                    ret.push(...getChildrenIds(children));
                });
                return ret;
            };

            let checkedAllKeys = [].concat(this.$refs.tree.getCheckedKeys(), this.$refs.tree.getHalfCheckedKeys());
            if (isCheck) {
                // 子节点都选中
                relatedNodes.push(...getChildrenIds(children));

                // 父节点都选中
                // 根节点没有path，不用做处理
                path && relatedNodes.push(...path.split("/"));
                path && relatedNodes.push("0");

                checkedAllKeys.push(...relatedNodes.filter(key => checkedAllKeys.indexOf(key) === -1));
            } else {
                // 子节点都去除选中
                relatedNodes.push(...getChildrenIds(children));
                checkedAllKeys = checkedAllKeys.filter(key => relatedNodes.indexOf(key) === -1);
            }

            this.tempKey = checkedAllKeys;
            this.$refs.tree.setCheckedKeys(checkedAllKeys);
        },
        getEditorTitle() {
            return this.data ? this.editRoleLabel : this.addRoleLabel;
        },
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        confirmClick() {
            let checkedData = {
                roleName: this.initRoleName,
                permitData: this.tempKey
            };
            // eslint-disable-next-line
            checkRoleData(checkedData) ? this.showErrorTips(checkRoleData(checkedData))
                : this.saveRoleEdit();
        },
        showErrorTips(errMessage) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "error",
                    message: errMessage
                }
            });
        },
        saveRoleEdit() {
            let requst = {
                roleName: this.initRoleName,
                remarkData: this.remarkData,
                permit: this.tempKey.filter(item => item != "0").join(",")
            };
            let requstUrl = "";
            if (this.data) {
                requstUrl = "updateRoleEdit";
                requst.roleId = this.data.rowId;
            } else {
                requstUrl = "saveRoleEdit";
            }
            this.zhiji.requestByServiceName(requstUrl, requst).then(() => {
                this.$store.dispatch("zhiji/queryRoleList", {});
                this.$store.commit("zhiji/clearRoleOption");
                this.close();
            });
        },
        nameChange(data) {
            this.initRoleName = data;
        },
        remarkChange(data) {
            this.remarkData = data;
        }
    }
};

// 校验编辑项
function checkRoleData(data) {
    if (!data.roleName) {
        return i18n.t("zhiji.personnel.roleManage.roleEditModal.checkRoleNameTip");
    }

    if (data.permitData.length == 0) {
        return i18n.t("zhiji.personnel.roleManage.roleEditModal.checkPermitTip");
    }
}
</script>

<style lang="less" scoped>
.role-edit-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .role-info-list {
        margin-top: 12px;
        font-size: 12px;

        .role-name-input {
            width: 400px;
            border: 1px solid #d8e4f0;
            border-radius: 4px;
        }

        .permiss-content {
            height: 350px;
            border: 1px solid #d8e4f0;
            width: 100%;
            border-radius: 4px;
            overflow-y: auto;

            .el-tree {
                background: #fff;
            }
        }
    }
    .work-group {
        display: flex;
        margin-top: 16px;
        height: 40px;
        line-height: 40px;

        .max-num-input {
            width: 300px;
            display: flex;
            margin-left: 20px;

            .max-work-input {
                border-radius: 4px;
                width: 100px;
                border: 1px solid #d8e4f0;
                height: 32px;
                margin-top: 4px;
                box-sizing: border-box;
                input {
                    vertical-align: top;
                }
            }
        }
    }

    .icon-font {
        font-size: 16px;
        margin-left: 6px;

        &:hover {
            color: rgba(46, 194, 255, 0.8);
        }
    }

    .edit-switch {
        margin-top: 6px;
    }
}
</style>
